import { Component } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui';
import { Loading } from '@/components/shared';
import { isChunkLoadError, reloadForNewBuild } from '@/utils/staleBuild';
import PropTypes from 'prop-types';

const Fallback = ({ reloading }) => {
	const { t } = useTranslation();

	if (reloading) {
		return (<div className="flex flex-auto flex-col h-[100vh]">
			<Loading loading={true} />
		</div>);
	}

	return (<div className="flex flex-col justify-center items-center gap-6 h-[100vh] px-4 text-center">
		<div className="flex flex-col gap-2">
			<h1 className="text-2xl font-bold">{t('Something went wrong')}</h1>
			<p className="text-neutral-500 dark:text-neutral-400">{t('Reload the page to continue. If the problem persists, try again in a few minutes.')}</p>
		</div>

		<Button variant="solid" onClick={() => window.location.reload()}>{t('Reload page')}</Button>
	</div>);
};

Fallback.propTypes = {
	reloading: PropTypes.bool,
};

class ErrorBoundary extends Component {
	state = { error: null, reloading: false };

	static getDerivedStateFromError(error) {
		return { error, reloading: isChunkLoadError(error) };
	}

	componentDidCatch(error) {
		if (this.state.reloading && reloadForNewBuild()) {
			return;
		}

		this.setState({ reloading: false });
		console.error(error);
	}

	render() {
		if (this.state.error) {
			return <Fallback reloading={this.state.reloading} />;
		}

		return this.props.children;
	}
}

ErrorBoundary.propTypes = {
	children: PropTypes.node,
};

export default ErrorBoundary;
